"use strict";
/* eslint-disable @typescript-eslint/no-non-null-assertion */
// @ts-nocheck
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const OverlayBuilder_1 = __importDefault(require("./ModelsT/OverlayBuilder"));
const RasterBuilder_1 = __importDefault(require("./ModelsT/RasterBuilder"));
const PointBuilder_1 = __importDefault(require("./ModelsT/PointBuilder"));
const BaseMapLayer_1 = __importDefault(require("./models/BaseMapLayer"));
const ZoneBuilder_1 = __importDefault(require("./ModelsT/ZoneBuilder"));
const DrawBuilder_1 = __importDefault(require("./ModelsT/DrawBuilder"));
const ExportBuilder_1 = __importDefault(require("./ModelsT/ExportBuilder"));
const geom_1 = require("ol/geom");
const style_1 = require("ol/style");
const ol_1 = require("ol");
const Utils_1 = require("./Utils");
const easing_1 = require("ol/easing");
const Modify_js_1 = __importDefault(require("ol/interaction/Modify.js"));
const Circle_js_1 = __importDefault(require("ol/style/Circle.js"));
const WKT_js_1 = __importDefault(require("ol/format/WKT.js"));
const proj_1 = require("ol/proj");
const source_1 = require("ol/source");
const Vector_1 = __importDefault(require("ol/layer/Vector"));
const DragBox_js_1 = __importDefault(require("ol/interaction/DragBox.js"));
const condition_js_1 = require("ol/events/condition.js");
const proj_2 = require("ol/proj");
const defaults_1 = require("ol/interaction/defaults");
/**
 * Controller for the map openlayer 7.5.0
 * @module OpenLayerMapController
 * @version 2.0.1
 * @description This controller allows us to create and manage the instance of a map with ol,
 *  from here we could create zones, points, rasters,... Thanks to the builders that are managed below
 *  as zoneBuilder, rasterBuilder etc...
 */
class Controller {
    constructor() {
        this.markerSelected = new ol_1.Feature();
        this.zoneSelected = new ol_1.Feature();
        this.selectedFeaturesFields = [];
        this.zoneSelectedSet = new ol_1.Feature();
        this.recoorIndicatorSelected = new ol_1.Feature();
        this.currentFieldModify = new ol_1.Feature();
        this.currentFieldModifyWKT = '';
        this.modyFeature = null;
        this.map = new ol_1.Map();
        this.zoneTooltipId = '';
        this.markerTooltipId = '';
        this.recoorsId = '';
        this.isLoadingMap = false;
        this.autoCenterEnabled = true;
        this.lastUpdateTimeout = null; // Almacena el timeout para evitar múltiples ejecuciones
        this.lastCoordinatesUrl = []; // Almacena la última URL generada
        this.lastCoordinatesUrl1 = ''; // Almacena la última URL generada
        this.lastCoordinatesUrl2 = ''; // Almacena la última URL generada
        this.lastCoordinatesUrl3 = '';
        this.drawInteraction = false;
        this.isMoving = false;
        this.currentZoom = 15;
        this.currentBaseLayerName = '';
        this.currentModifyInteraction = null;
        this.currentVectorSource = null;
        this.modyFeature = null;
        this.lastSelectedFeature = null; // Variable para almacenar la última feature seleccionada
    }
    searchLocation(location) {
        const coordinates = location.split(/[^-0-9.]+/).map(coord => coord.trim()).filter(coord => coord !== '');
        if (coordinates.length !== 2) {
            return false;
        }
        const [lat, lon] = coordinates.map(Number);
        const centerCoordinates = (0, proj_2.fromLonLat)([lon, lat]);
        // Centrar el mapa
        this.map.getView().setCenter(centerCoordinates);
    }
    getScreenCoordinatesUrl(reduction = 2500, rows = 2, cols = 2) {
        const view = this.map.getView();
        let extent = view.calculateExtent(this.map.getSize());
        const sourceProjection = view.getProjection();
        const targetProjection = 'EPSG:4326'; // Proyección deseada
        // Calcular centro y definir cuadrado de 2500m²
        const [minX, minY, maxX, maxY] = extent;
        const centerX = (minX + maxX) / 2;
        const centerY = (minY + maxY) / 2;
        const halfSide = reduction / 2;
        extent = [
            centerX - halfSide,
            centerY - halfSide,
            centerX + halfSide,
            centerY + halfSide
        ];
        // Transformar solo una vez las coordenadas a EPSG:4326
        const corners = [
            [extent[0], extent[1]],
            [extent[0], extent[3]],
            [extent[2], extent[3]],
            [extent[2], extent[1]] // Inferior derecha
        ].map(coord => (0, proj_1.transform)(coord, sourceProjection, targetProjection));
        // Asegurar que la geometría esté cerrada
        const coordsArray = [...corners, corners[0]];
        // Generar las sub-áreas dividiendo la extensión transformada
        const subAreas = this.splitBoundingBox(corners[0], corners[2], rows, cols);
        // Generar URLs con mejor manejo de parámetros
        return subAreas.map(area => {
            const params = new URLSearchParams();
            const closedArea = [...area, area[0]]; // Cerrar el área
            closedArea.forEach(coord => params.append('coords[]', `${coord[0].toFixed(6)},${coord[1].toFixed(6)}`));
            return `/integrations/varda/fields/list?${params.toString()}`;
        });
    }
    splitBoundingBox(bottomLeft, topRight, rows, cols) {
        const latStep = (topRight[1] - bottomLeft[1]) / rows;
        const lngStep = (topRight[0] - bottomLeft[0]) / cols;
        const subAreas = [];
        for (let i = 0; i < rows; i++) {
            for (let j = 0; j < cols; j++) {
                const sw = [bottomLeft[0] + j * lngStep, bottomLeft[1] + i * latStep];
                const ne = [bottomLeft[0] + (j + 1) * lngStep, bottomLeft[1] + (i + 1) * latStep];
                // Crear el polígono cerrado directamente
                subAreas.push([
                    sw,
                    [sw[0], ne[1]],
                    ne,
                    [ne[0], sw[1]],
                    sw // Cerrar el polígono
                ]);
            }
        }
        return subAreas;
    }
    debounceUpdate() {
        if (this.lastUpdateTimeout)
            clearTimeout(this.lastUpdateTimeout);
        this.lastUpdateTimeout = setTimeout(() => {
            const newUrls = this.getScreenCoordinatesUrl(2500);
            if (JSON.stringify(newUrls) !== JSON.stringify(this.lastCoordinatesUrl)) {
                this.lastCoordinatesUrl = newUrls;
            }
        }, 2000);
    }
    get projections() {
        return { dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857' };
    }
    get zoneBuilder() {
        return new ZoneBuilder_1.default(this.map);
    }
    get pointBuilder() {
        return new PointBuilder_1.default(this.map);
    }
    get rasterBuilder() {
        return new RasterBuilder_1.default(this.map);
    }
    get drawBuilder() {
        return new DrawBuilder_1.default(this.map);
    }
    get overlayBuilder() {
        return new OverlayBuilder_1.default(this.map);
    }
    get exportBuilder() {
        return new ExportBuilder_1.default(this.map);
    }
    get currentRecoorIndicatorSelected() {
        return this.recoorIndicatorSelected;
    }
    get currentMarkerSelected() {
        return this.markerSelected;
    }
    get currentzoneSelected() {
        return this.zoneSelected;
    }
    restoreSelectedFeaturesStyles(fieldId) {
        this.selectedFeaturesFields = this.selectedFeaturesFields.filter((feature) => {
            if (feature.get('name') === fieldId) {
                const originalStyle = feature.get('style'); // Asume que el estilo original está almacenado aquí
                if (originalStyle) {
                    feature.setStyle(new style_1.Style({
                        fill: feature.get('style').getFill(),
                        stroke: originalStyle.getStroke(),
                        zIndex: 20
                    }));
                }
                return false; // Excluye este elemento de la nueva lista
            }
            return true; // Mantiene los demás elementos
        });
    }
    drawBoxInteraction() {
        const dragBox = new DragBox_js_1.default({
            condition: condition_js_1.platformModifierKeyOnly,
            className: 'select-box'
        });
        this.map.addInteraction(dragBox);
        dragBox.on('boxstart', () => {
            this.map.unset('pointermove');
            this.map.unset('singleclick');
            this.map.getViewport().style.cursor = 'url(/images/map/resources/box-selection.svg) 0 -10, auto';
        });
        // Seleccionar elementos dentro del box
        dragBox.on('boxend', () => {
            this.map.on('pointermove');
            this.map.on('singleclick');
            this.map.getViewport().style.cursor = '';
            const extent = dragBox.getGeometry().getExtent();
            const layer = (0, Utils_1.findLayerById)('zone-layer', this.map);
            const selectedFeatures = layer.getSource()
                .getFeatures()
                .filter((feature) => feature.getGeometry().intersectsExtent(extent));
            // Mostrar los elementos seleccionados en consola
            selectedFeatures.forEach((feature) => {
                const featureName = feature.get('name');
                const exists = this.selectedFeaturesFields.some((f) => f.get('name') === featureName);
                if (!exists)
                    this.selectedFeaturesFields.push(feature);
                // Verifica si el elemento ya está en `selectedFields` antes de añadirlo
                feature.setStyle(new style_1.Style({
                    fill: feature.get('style').getFill(),
                    stroke: new style_1.Stroke({ color: '#fff', width: 3 }),
                    zIndex: 20
                }));
            });
        });
    }
    enabledFullScreen() {
        const mapContainer = document.getElementById(this.map.getTarget()); // Contenedor del mapa
        if (mapContainer) {
            // Verificar si el navegador soporta el modo de pantalla completa
            if (mapContainer.requestFullscreen) {
                mapContainer.requestFullscreen();
            }
            else if (mapContainer.mozRequestFullScreen) { // Firefox
                mapContainer.mozRequestFullScreen();
            }
            else if (mapContainer.webkitRequestFullscreen) { // Chrome, Safari
                mapContainer.webkitRequestFullscreen();
            }
            else if (mapContainer.msRequestFullscreen) { // IE/Edge
                mapContainer.msRequestFullscreen();
            }
        }
    }
    disabledFullScreen() {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        }
        else if (document.mozCancelFullScreen) { // Firefox
            document.mozCancelFullScreen();
        }
        else if (document.webkitExitFullscreen) { // Chrome, Safari
            document.webkitExitFullscreen();
        }
        else if (document.msExitFullscreen) { // IE/Edge
            document.msExitFullscreen();
        }
    }
    setZoneSelected(feature) {
        if (feature) {
            this.zoneSelected = feature;
            this.fitExtent(feature.getGeometry().getExtent());
        }
    }
    activeLoadingMap() {
        var _a;
        this.isLoadingMap = true;
        this.map.getTargetElement().classList.add('spinner');
        (_a = document.querySelector('.bmfw-container-result-map')) === null || _a === void 0 ? void 0 : _a.classList.add('loading-map');
    }
    removeLoadingMap() {
        var _a;
        this.isLoadingMap = false;
        this.map.getTargetElement().classList.remove('spinner');
        (_a = document.querySelector('.bmfw-container-result-map')) === null || _a === void 0 ? void 0 : _a.classList.remove('loading-map');
    }
    create(id, provider, apikey, zoneId, markerId, recoorId, initZoom, minZoom, maxZoom) {
        const view = new ol_1.View({ zoom: initZoom || 13, center: [-10352712.64, 5236173.78], maxZoom: maxZoom || 20, minZoom: minZoom || 0 });
        const baseLayer = new BaseMapLayer_1.default(provider, apikey).layers;
        this.map = new ol_1.Map({ target: id, layers: baseLayer, view: view, controls: [], interactions: (0, defaults_1.defaults)({ doubleClickZoom: false }) });
        this.markerTooltipId = markerId;
        this.zoneTooltipId = zoneId;
        this.recoorsId = recoorId;
        const mapElement = this.map.getTargetElement();
        this.map.on('movestart', () => {
            this.isMoving = true;
            mapElement.style.cursor = 'all-scroll'; // Cambia el cursor a "grabbing";
            this.map.unset('pointermove');
            this.map.unset('singleclick');
        });
        // Agrega un listener al evento 'moveend' del mapa
        this.map.on('moveend', () => {
            this.map.on('pointermove');
            this.map.on('singleclick');
            this.isMoving = false;
            this.debounceUpdate();
            mapElement.style.cursor = '';
            this.currentZoom = this.map.getView().getZoom();
        });
        this.map.on('loadstart', () => {
            var _a;
            this.isLoadingMap = true;
            this.map.getTargetElement().classList.add('spinner');
            (_a = document.querySelector('.bmfw-container-result-map')) === null || _a === void 0 ? void 0 : _a.classList.add('loading-map');
            setTimeout(() => {
                var _a;
                this.isLoadingMap = false;
                this.map.getTargetElement().classList.remove('spinner');
                (_a = document.querySelector('.bmfw-container-result-map')) === null || _a === void 0 ? void 0 : _a.classList.remove('loading-map');
            }, 1500);
        });
        this.map.on('loadend', () => {
            var _a;
            this.isLoadingMap = false;
            this.map.getTargetElement().classList.remove('spinner');
            (_a = document.querySelector('.bmfw-container-result-map')) === null || _a === void 0 ? void 0 : _a.classList.remove('loading-map');
        });
        // ********* SWITCHLAYER ********* 
        this.map.getView().on('change:resolution', () => {
            const zoom = this.map.getView().getZoom();
            if (zoom > 17) {
                if (this.currentBaseLayerName !== 'OSM') {
                    this.currentBaseLayerName = 'OSM';
                    this.switchLayer('OSM', apikey);
                }
            }
            else if (zoom <= 17) {
                if (this.currentBaseLayerName !== 'AzureMaps') {
                    this.currentBaseLayerName = 'AzureMaps';
                    this.switchLayer('AzureMaps', apikey);
                }
            }
        });
        // ********* SWITCHLAYER ********* 
        this.addHoverInteractions();
        //this.addSelectInteractions();
    }
    applyDrawBox() {
        this.drawBoxInteraction();
    }
    applyControl() {
        this.addSelectInteractionsControl();
    }
    switchLayer(provider, apikey) {
        const newBaseLayer = new BaseMapLayer_1.default(provider, apikey).layers[0];
        if (!this.currentBaseLayer || this.currentBaseLayer !== newBaseLayer) {
            if (this.currentBaseLayer) {
                this.map.removeLayer(this.currentBaseLayer);
            }
            this.map.addLayer(newBaseLayer);
            this.currentBaseLayer = newBaseLayer;
        }
    }
    fitExtent(extent) {
        this.map.getView().fit(extent, { size: this.map.getSize(), maxZoom: this.map.getView().getZoom(), easing: easing_1.easeOut, duration: 500, constrainResolution: true });
    }
    zoomIn() {
        const currentZoom = this.map.getView().getZoom();
        const maxZoom = this.map.getView().getMaxZoom();
        if (currentZoom && currentZoom < maxZoom)
            this.map.getView().setZoom(currentZoom + 1);
    }
    zoomOut() {
        const currentZoom = this.map.getView().getZoom();
        const minZoom = this.map.getView().getMinZoom();
        if (currentZoom && currentZoom > minZoom)
            this.map.getView().setZoom(currentZoom - 1);
    }
    changeCenter(newCenter) {
        if (this.map) {
            const view = this.map.getView();
            view.setCenter(newCenter);
        }
    }
    desactivarEdicionPoligonos() {
        // Added THis!
        if (this.currentVectorSource) {
            this.currentVectorSource.clear();
            this.currentVectorSource = null;
        }
        // Remover la capa de puntos existente (si la hay)
        if (this.vertexLayer) {
            this.map.removeLayer(this.vertexLayer);
            this.vertexLayer = null;
        }
        if (this.map.modifyInteraction) {
            this.map.removeInteraction(this.map.modifyInteraction);
            this.map.modifyInteraction = null;
        }
    }
    activarEdicionPoligonos(feature) {
        if (this.currentModifyInteraction) {
            this.map.removeInteraction(this.currentModifyInteraction);
            this.currentModifyInteraction = null;
        }
        if (this.currentVectorSource) {
            this.currentVectorSource.clear();
            this.currentVectorSource = null;
        }
        // Remover la capa de puntos existente (si la hay)
        if (this.vertexLayer) {
            this.map.removeLayer(this.vertexLayer);
            this.vertexLayer = null;
        }
        this.modyFeature = feature;
        // Fuente para el polígono
        const vectorSource = new source_1.Vector({ features: [feature] });
        this.currentVectorSource = vectorSource;
        // Crear capa de puntos para los vértices
        const vertexSource = this.crearPuntosDeVertices(feature, 1); // Usa tolerancia para simplificar
        const vertexLayer = new Vector_1.default({
            source: vertexSource,
            style: new style_1.Style({
                image: new Circle_js_1.default({
                    radius: 10,
                    fill: new style_1.Fill({ color: '#FFFFFF' }),
                    stroke: new style_1.Stroke({ color: '#000000', width: 1 }) // Borde negro
                })
            }),
            zIndex: 11
        });
        vertexLayer.set('id', 'vertex-layer');
        this.vertexLayer = vertexLayer;
        this.map.addLayer(vertexLayer); // Añadir la capa de vértices al mapa
        // Crear interacción de modificación
        const modifyInteraction = new Modify_js_1.default({
            source: vectorSource, style: new style_1.Style({
                image: new Circle_js_1.default({
                    radius: 10,
                    fill: new style_1.Fill({ color: '#FFFFFF' }),
                    stroke: new style_1.Stroke({ color: '#000000', width: 1 }) // Borde negro
                })
            })
        });
        this.currentModifyInteraction = modifyInteraction;
        this.map.addInteraction(modifyInteraction);
        modifyInteraction.on('modifystart', () => {
            if (this.vertexLayer) {
                this.map.removeLayer(this.vertexLayer);
            }
        });
        // Mostrar la capa de puntos al terminar la modificación
        modifyInteraction.on('modifyend', (event) => {
            const modifiedFeature = event.features.item(0);
            this.currentFieldModify = event.features.item(0);
            // Actualizar los puntos de vértices
            this.actualizarPuntosDeVertices(modifiedFeature);
            // Volver a añadir la capa de puntos
            if (!this.map.getLayers().getArray().includes(this.vertexLayer)) {
                this.map.addLayer(this.vertexLayer);
            }
            const geometry = modifiedFeature
                .getGeometry()
                .simplify(10)
                .clone()
                .transform('EPSG:3857', 'EPSG:4326');
            const multiPolygonGeometry = geometry instanceof geom_1.MultiPolygon
                ? geometry
                : new geom_1.MultiPolygon([geometry.getCoordinates()]);
            const wktFormat = new WKT_js_1.default();
            this.currentFieldModifyWKT = wktFormat.writeGeometry(multiPolygonGeometry);
        });
    }
    // Crear puntos de vértices desde la geometría, con simplificación
    crearPuntosDeVertices(feature, tolerance) {
        const vertexFeatures = [];
        const geometry = feature.getGeometry().simplify(tolerance); // Simplificar la geometría
        if (geometry.getType() === 'Polygon') {
            const coordinates = geometry.getCoordinates()[0];
            for (const coord of coordinates) {
                vertexFeatures.push(new ol_1.Feature(new geom_1.Point(coord)));
            }
        }
        else if (geometry.getType() === 'MultiPolygon') {
            const coordinates = geometry.getCoordinates()[0][0];
            for (const coord of coordinates) {
                vertexFeatures.push(new ol_1.Feature(new geom_1.Point(coord)));
            }
        }
        return new source_1.Vector({ features: vertexFeatures });
    }
    // Actualizar los puntos de los vértices con simplificación
    actualizarPuntosDeVertices(feature) {
        if (this.vertexLayer) {
            const vertexSource = this.vertexLayer.getSource();
            vertexSource.clear();
            const vertexFeatures = [];
            const geometry = feature.getGeometry();
            if (geometry) {
                if (geometry.getType() === 'Polygon') {
                    const coordinates = geometry.getCoordinates()[0];
                    for (const coord of coordinates) {
                        vertexFeatures.push(new ol_1.Feature(new geom_1.Point(coord)));
                    }
                }
                else if (geometry.getType() === 'MultiPolygon') {
                    const coordinates = geometry.getCoordinates()[0][0];
                    for (const coord of coordinates) {
                        vertexFeatures.push(new ol_1.Feature(new geom_1.Point(coord)));
                    }
                }
            }
            vertexSource.addFeatures(vertexFeatures);
        }
    }
    findRightmostPoint(geometry) {
        let maxX = -Infinity;
        let maxY = -Infinity;
        let rightmostPoint = null;
        const processCoordinates = (coords) => {
            for (const [x, y] of coords) {
                if (x > maxX || (x === maxX && y > maxY)) {
                    maxX = x;
                    maxY = y;
                    rightmostPoint = [x, y];
                }
            }
        };
        if (geometry instanceof geom_1.Polygon) {
            geometry.getCoordinates().forEach(processCoordinates);
        }
        else if (geometry instanceof geom_1.MultiPolygon) {
            geometry.getCoordinates().forEach(polygon => polygon.forEach(processCoordinates));
        }
        return rightmostPoint;
    }
    clearFeatureStyle(feature) {
        this.overlayBuilder.visibilityOverlay(this.markerTooltipId, false);
        this.overlayBuilder.visibilityOverlay(this.zoneTooltipId, false);
        feature.setStyle(feature.get('style'));
        this.zoneSelected = null;
    }
    clearOverlays() {
        if (this.overlayBuilder.findOverlay(this.markerTooltipId))
            this.overlayBuilder.visibilityOverlay(this.markerTooltipId, false);
        if (this.overlayBuilder.findOverlay(this.zoneTooltipId))
            this.overlayBuilder.visibilityOverlay(this.zoneTooltipId, false);
        if (this.overlayBuilder.findOverlay(this.recoorsId))
            this.overlayBuilder.visibilityOverlay(this.recoorsId, false);
    }
    getFeatureStyle(feature) {
        if (feature.get('selectInteraction')) {
            // Solo ejecutamos la lógica si la feature seleccionada es diferente a la anterior
            if (feature) {
                // Aquí solo ejecutamos la lógica de estilo y edición si es una nueva feature seleccionada
                if (feature.get('layerId') === 'zone-layer') {
                    if (feature.get('modifyInteraction') === true && this.modyFeature && feature.get('name') !== this.modyFeature.get('name')) {
                        this.activarEdicionPoligonos(feature);
                        // this.currentFieldModifyWKT = new WKT().writeGeometry(feature.getGeometry().transform('EPSG:3857', 'EPSG:4326'));
                    }
                    else if (feature.get('modifyInteraction') === true && !this.modyFeature) {
                        this.activarEdicionPoligonos(feature);
                    }
                    this.overlayBuilder.addOverlay(this.zoneTooltipId, this.findRightmostPoint(feature.getGeometry()));
                    this.overlayBuilder.visibilityOverlay(this.zoneTooltipId, true);
                    this.zoneSelected = feature;
                    this.lastSelectedFeature = feature; // Actualizamos la última feature seleccionada
                    return new style_1.Style({
                        fill: feature.get('style').getFill(),
                        stroke: new style_1.Stroke({ color: '#fff', width: 3 }),
                        zIndex: 20,
                    });
                }
                else if (feature.get('layerId') === 'point-layer') {
                    const icon = new style_1.Icon({
                        anchor: [10, 50],
                        src: '/images/map/resources/tube-icon.svg',
                        scale: 1.1,
                        color: feature.get('icon').getColor(),
                    });
                    this.overlayBuilder.addOverlay(this.markerTooltipId, feature.getGeometry().getCoordinates());
                    this.overlayBuilder.visibilityOverlay(this.markerTooltipId, true);
                    this.markerSelected = feature;
                    this.lastSelectedFeature = feature; // Actualizamos la última feature seleccionada
                    return new style_1.Style({ image: icon });
                }
            }
            else {
                // Si es la misma feature seleccionada, devolvemos su estilo sin ejecutar más lógica
                return feature.get('style');
            }
        }
        else {
            this.clearFeatureStyle(feature);
            return feature.get('style');
        }
    }
    resetZoneLayerStyles() {
        const layer = (0, Utils_1.findLayerById)('zone-layer', this.map);
        if (layer) {
            const selectedFeatures = layer.getSource().getFeatures();
            selectedFeatures.forEach((feature) => {
                feature.setStyle(feature.get('style'));
            });
        }
    }
    addSelectMultiInteractions() {
        this.map.on('singleclick', (event) => {
            var _a;
            if (this.drawInteraction) {
                return;
            }
            const clickedFeature = this.map.forEachFeatureAtPixel(event.pixel, (feature) => feature);
            if (clickedFeature) {
                clickedFeature === null || clickedFeature === void 0 ? void 0 : clickedFeature.setStyle(new style_1.Style({
                    fill: (_a = clickedFeature === null || clickedFeature === void 0 ? void 0 : clickedFeature.get('style')) === null || _a === void 0 ? void 0 : _a.getFill(),
                    stroke: new style_1.Stroke({ color: '#fff', width: 3 }),
                    zIndex: 20,
                }));
                const featureName = clickedFeature ? (clickedFeature === null || clickedFeature === void 0 ? void 0 : clickedFeature.get('name')) || '' : '';
                const exists = this.selectedFeaturesFields.some((f) => f.get('name') === featureName);
                if (!exists) {
                    this.selectedFeaturesFields.push(clickedFeature);
                }
                else {
                    this.selectedFeaturesFields = this.selectedFeaturesFields.filter((f) => f.get('name') !== featureName);
                    clickedFeature.setStyle(clickedFeature.get('style'));
                }
            }
        });
    }
    addSelectInteractions() {
        this.map.on('singleclick', (event) => {
            if (this.drawInteraction) {
                return;
            }
            // Verificar si la tecla Control no está presionada
            (0, Utils_1.removeLayerById)('vertex-layer', this.map);
            const clickedFeature = this.map.forEachFeatureAtPixel(event.pixel, (feature) => feature);
            if (clickedFeature && clickedFeature.get('selectInteraction')) {
                clickedFeature.setStyle(this.getFeatureStyle(clickedFeature));
                this.map.getLayers().forEach((layer) => {
                    const source = layer.getSource();
                    if (source && source.forEachFeature) {
                        source.forEachFeature((feature) => {
                            // Si la feature no está seleccionada, restaurar su estilo original
                            if (feature !== clickedFeature || !feature.get('selectInteraction') && !this.selectedFeaturesFields.some((f) => f.get('name') === feature.get('name'))) {
                                feature.setStyle(feature.get('style'));
                            }
                        });
                    }
                });
            }
            else {
                this.desactivarEdicionPoligonos();
                this.zoneSelected = null;
                this.resetZoneLayerStyles();
                if (this.overlayBuilder.findOverlay(this.markerTooltipId))
                    this.overlayBuilder.visibilityOverlay(this.markerTooltipId, false);
                if (this.overlayBuilder.findOverlay(this.zoneTooltipId))
                    this.overlayBuilder.visibilityOverlay(this.zoneTooltipId, false);
                if (this.overlayBuilder.findOverlay(this.recoorsId))
                    this.overlayBuilder.visibilityOverlay(this.recoorsId, false);
            }
        });
    }
    addSelectInteractionsControl() {
        /*  map.on('singleclick', (event) => {
             // Verificar si la tecla Control está presionada
             if (event.originalEvent.ctrlKey) {
                
                 event.selected.forEach((feature: Feature) => {
                     feature.setStyle( new Style({
                         fill: feature.get('style').getFill(),
                         stroke: new Stroke({ color: '#fff', width: 5 }),
                         zIndex: 20,
                     }));
                 })
                 event.deselected.forEach((feature: Feature) => {
                     this.map.removeInteraction(this.currentModifyInteraction); // Eliminar la interacción del mapa
                     removeLayerById('vertex-layer', this.map);
                     this.modyFeature = null;
                     if (event.selected.length === 0) {
                         this.zoneSelected = null;
                     }
                 });
             } */
    }
    addHoverInteractions() {
        let lastHoveredFeature = null;
        let originalStyle = null;
        const mapElement = this.map.getTargetElement();
        this.map.on('pointermove', (event) => {
            if (this.isMoving || this.drawInteraction)
                return;
            const pixel = event.pixel;
            let hoveredFeature = null;
            this.map.forEachFeatureAtPixel(pixel, (feature) => {
                hoveredFeature = feature;
                return true;
            });
            if (hoveredFeature && hoveredFeature.get('hover') &&
                (hoveredFeature.getGeometry() instanceof geom_1.MultiPolygon || hoveredFeature.getGeometry() instanceof geom_1.Polygon)) {
                mapElement.style.cursor = 'pointer';
                if (hoveredFeature !== lastHoveredFeature) {
                    if (lastHoveredFeature && lastHoveredFeature !== this.zoneSelected &&
                        !this.selectedFeaturesFields.includes(lastHoveredFeature)) {
                        lastHoveredFeature.setStyle(originalStyle);
                    }
                    // Aplicar el nuevo estilo si la feature tiene la propiedad 'hover'
                    if (hoveredFeature.get('hover') && hoveredFeature !== this.zoneSelected &&
                        !this.selectedFeaturesFields.includes(hoveredFeature)) {
                        originalStyle = hoveredFeature.getStyle();
                        hoveredFeature.setStyle(new style_1.Style({
                            fill: new style_1.Fill({ color: '#ffffff50' }),
                            stroke: new style_1.Stroke({ color: '#FFF', width: 3 }),
                            zIndex: 20
                        }));
                    }
                    lastHoveredFeature = hoveredFeature;
                }
            }
            else {
                // Si no hay feature en hover, restaurar la última feature hovereada
                if (lastHoveredFeature && lastHoveredFeature !== this.zoneSelected &&
                    !this.selectedFeaturesFields.includes(lastHoveredFeature)) {
                    lastHoveredFeature.setStyle(originalStyle);
                }
                lastHoveredFeature = null;
                mapElement.style.cursor = '';
            }
        });
    }
    addTileLayerToMap() {
        // Crear la capa de tiles
        /* const tileLayer = new TileLayer({
          source: new XYZ({
            url: 'https://api.maptiler.com/tiles/aed6e8c4-ca90-4e90-9ed3-c8893144eb0c/{z}/{x}/{y}.webp?key=0qOtv2B4cP2DQltIw0Gw', // Esquema dinámico
          }),
          zIndex: 9999, // Opcional: Controlar el orden de apilamiento de capas
        });
    
        // Agregar la capa al mapa
        this.map.addLayer(tileLayer); */
    }
}
exports.default = Controller;
